<template>
  <div id="app">
    <div class="sticky-nav px-4">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">Bestellingen</h1>
      </div>

      <div class="dropdown">
        <button
          class="btn btn-dark"
          type="button"
          id="dropdownMenuButton"
          v-on:click="modalToevoegenBestelling()"
        >
          <i class="fas fa-plus"></i> Bestelling toevoegen
        </button>
      </div>
    </div>

    <br />
    <br />

    <vue-good-table
      v-if="bestellingen && bestellingen.length"
      class="mb-3 px-4"
      @on-selected-rows-change="selectionChanged"
      @on-cell-click="onRowClick"
      :columns="bestellingColumns"
      :rows="bestellingen"
      :pagination-options="{
        enabled: true,
        mode: 'pages',
        perPage: 100,
        position: 'bottom',
        perPageDropdown: [25, 50, 100],
        setCurrentPage: 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
        dropdownAllowAll: true,
      }"
      :selectOptions="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
      }"
    />

    <!-- Modal -->
    <div
      class="modal fade"
      id="bestellingModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="bestelling && bestelling.klant_info"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ editModalTitle }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation">
                <a
                  class="nav-link active show"
                  href="#leveringTab"
                  aria-controls="leveringTab"
                  role="tab"
                  data-toggle="tab"
                  >Levering</a
                >
              </li>
              <li role="presentation">
                <a
                  class="nav-link"
                  href="#ophalingTab"
                  aria-controls="ophalingTab"
                  role="tab"
                  data-toggle="tab"
                  >Ophaling</a
                >
              </li>
              <li role="presentation">
                <a
                  class="nav-link"
                  href="#fotosTab"
                  aria-controls="fotosTab"
                  role="tab"
                  data-toggle="tab"
                  >Foto's</a
                >
              </li>
            </ul>

            <div class="tab-content">
              <div
                role="tabpanel"
                class="tab-pane active"
                id="leveringTab"
                v-if="bestelling"
              >
                <label>Datum</label>
                <date-picker
                  v-model="bestelling.leveringsdatum"
                  placeholder="Kies datum"
                  :value-type="'YYYY-MM-DD'"
                  :editable="false"
                  :format="'YYYY-MM-DD'"
                  @change="checkBeschikbaarheid"
                ></date-picker>
                <label>Richtuur</label>
                <vue-timepicker
                  v-model="bestelling.leveringsrichtuur"
                  :minute-interval="15"
                ></vue-timepicker>
                <hr />
                <label>Container</label>
                <select
                  class="form-control"
                  v-model="bestelling.container"
                  :disabled="beschikbaarheidscheck"
                  @change="checkBeschikbaarheidFeedback"
                >
                  <option value>- Kies een container -</option>
                  <option
                    v-for="container in containers"
                    :key="container.id"
                    :value="container.id"
                    :disabled="!container.beschikbaar"
                    :selected="bestelling.container"
                  >
                    {{ container.beschrijving }} ({{ container.grootte }}m³)
                  </option>
                </select>
                <p
                  class="d-flex justify-content-end"
                  v-html="beschikbaarheidFeedback"
                >
                  {{ beschikbaarheidFeedback }}
                </p>
                <!--
                <label>Vrachtwagen</label>
                <select
                  class="form-control"
                  v-model="bestelling.leveringsvrachtwagen"
                  :disabled="beschikbaarheidscheck"
                >
                  <option value>- Kies een vrachtwagen -</option>
                  <option
                    v-for="vrachtwagen in vrachtwagens"
                    :key="vrachtwagen.id"
                    :value="vrachtwagen.id"
                    :selected="bestelling.vrachtwagen"
                  >
                    {{ vrachtwagen.beschrijving }} ({{
                      vrachtwagen.nummerplaat
                    }})
                  </option>
                </select>
                <label>Chauffeur</label>
                <select
                  class="form-control"
                  v-model="bestelling.leveringschauffeur"
                  :disabled="beschikbaarheidscheck"
                >
                  <option value>- Kies een chauffeur -</option>
                  <option
                    v-for="chauffeur in chauffeurs"
                    :key="chauffeur.id"
                    :value="chauffeur.id"
                    :selected="bestelling.chauffeur"
                  >
                    {{ chauffeur.naam }}
                  </option>
                </select>
                -->
                <hr />
                <label>Klant</label>
                <model-list-select
                  :list="klanten"
                  option-value="id"
                  option-text="klantnaam"
                  v-model="bestelling.klant"
                  placeholder="- Kies klant -"
                  @input="changeCustomer"
                ></model-list-select>
                <div v-if="bestelling.klant">
                  <label>Werf</label>
                  <div class="idem-container">
                    <select
                      v-if="bestelling.gegevens_idem_klant !== '1'"
                      class="form-control"
                      v-model="bestelling.werf"
                      @change="changeWerf()"
                    >
                      <option value>- Kies een werf -</option>
                      <option value="new">Nieuwe werf aanmaken</option>
                      <template v-for="werf in werven">
                        <option
                          :key="werf.id"
                          :value="werf.id"
                          :selected="bestelling.werf"
                        >
                          {{ werf.beschrijving }}
                        </option>
                        <option :key="werf.id" disabled
                          >&#8627; {{ werf.straat }} {{ werf.huisnummer }} -
                          {{ werf.gemeente }}</option
                        >
                      </template>
                    </select>
                    <input
                      id="idem"
                      class="idem"
                      type="checkbox"
                      v-model="bestelling.gegevens_idem_klant"
                      true-value="1"
                      false-value="0"
                    />
                    <label class="idem" for="idem"
                      >Alle gegevens overnemen van klant?</label
                    >
                  </div>
                </div>

                <label>Afvalproduct</label>
                <select class="form-control" v-model="bestelling.afvalproduct">
                  <option value>- Kies een afvalproduct -</option>
                  <option
                    v-for="afvalproduct in afvalproducten"
                    :key="afvalproduct.id"
                    :value="afvalproduct.id"
                    :selected="bestelling.afvalproduct"
                  >
                    {{ afvalproduct.beschrijving }}
                  </option>
                </select>
                <hr />
                <label>Betalingswijze</label>
                <select
                  class="form-control"
                  v-model="bestelling.betalingswijze"
                  :selected="bestelling.betalingswijze"
                >
                  <option value disabled>- Kies betalingswijze -</option>
                  <option value="Factuur">Factuur</option>
                  <option value="Overschrijving voor levering">
                    Overschrijving voor levering
                  </option>
                  <option value="Contant">Contant</option>
                  <option value="Bancontact">Bancontact</option>
                </select>
                <!--
                <div v-if="bestelling.betalingswijze == 'Overschrijving'">
                  <label>Leverbon nr.</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="bestelling.leverbon"
                  />
                </div>
                -->
                <div v-if="bestelling.klant_info.type == 'Particulier'">
                  <label>Factuur (?)</label>
                  <select
                    class="form-control"
                    v-model="bestelling.factuur"
                    :selected="bestelling.factuur"
                  >
                    <option value="1">Ja</option>
                    <option value="0">Nee</option>
                  </select>
                </div>
                <label>Betalingstermijn</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="bestelling.klant_info.betalingstermijn"
                  disabled
                />
                <label>Prijsberekening</label>
                <select
                  class="form-control"
                  v-model="bestelling.prijsberekening"
                  :selected="bestelling.prijsberekening"
                >
                  <option value disabled>- Kies prijsberekening -</option>
                  <option value="Forfaitair">Forfaitair</option>
                  <option value="Prijs per ton">Prijs per ton</option>
                  <option value="Speciaal">Speciaal</option>
                </select>
                <div v-if="bestelling.prijsberekening == 'Speciaal'">
                  <label>Prijs (€)</label>
                  <input
                    v-model="bestelling.prijs_speciaal"
                    type="text"
                    class="form-control"
                  />
                </div>
                <div>
                  <label>Transport zone</label>
                  <select
                    class="form-control"
                    v-model="bestelling.transportzone"
                    v-if="bestelling.prijsberekening == 'Forfaitair'"
                  >
                    <option value>- Kies een transportzone -</option>
                    <option
                      v-for="transportzone in transportzones_ff"
                      :key="transportzone.id"
                      :value="transportzone.id"
                      :selected="bestelling.transportzone"
                    >
                      {{ transportzone.beschrijving }} -
                      {{ transportzone.type }} (€{{ transportzone.prijs }})
                    </option>
                  </select>
                  <select
                    class="form-control"
                    v-model="bestelling.transportzone"
                    v-else
                  >
                    <option value>- Kies een transportzone -</option>
                    <option
                      v-for="transportzone in transportzones_pt"
                      :key="transportzone.id"
                      :value="transportzone.id"
                      :selected="bestelling.transportzone"
                    >
                      {{ transportzone.beschrijving }} -
                      {{ transportzone.type }} (€{{ transportzone.prijs }})
                    </option>
                  </select>
                </div>
                <label>Notities</label>
                <textarea
                  class="form-control"
                  v-model="bestelling.notities_levering"
                  placeholder="Notities"
                ></textarea>
                <hr />
                <div v-if="checkNewBestelling === true">
                  <label>Verstuur mail?</label>
                  <select class="form-control" v-model="bestelling.mail">
                    <option value="1">Ja</option>
                    <option value="0">Nee</option>
                  </select>
                </div>
                <button
                  v-if="checkNewBestelling === false"
                  type="button"
                  class="btn btn-secondary float-right mt-2"
                  v-on:click="printVrachtbon(bestelling.id, 'plaatsing')"
                >
                  Print vrachtbon
                </button>
              </div>

              <div
                role="tabpanel"
                class="tab-pane"
                id="ophalingTab"
                v-if="bestelling"
              >
                <label>Datum</label>
                <date-picker
                  v-model="bestelling.ophalingsdatum"
                  :value-type="'YYYY-MM-DD'"
                  :format="'YYYY-MM-DD'"
                  :editable="false"
                  placeholder="Kies datum"
                ></date-picker>
                <label>Richtuur</label>
                <vue-timepicker
                  v-model="bestelling.ophalingsrichtuur"
                  :minute-interval="15"
                  @input="checkinput"
                ></vue-timepicker>
                <hr />
                <label>Vrachtwagen</label>
                <select
                  class="form-control"
                  v-model="bestelling.ophalingsvrachtwagen"
                  :disabled="beschikbaarheidscheck"
                >
                  <option value>- Kies een vrachtwagen -</option>
                  <option
                    v-for="vrachtwagen in vrachtwagens"
                    :key="vrachtwagen.id"
                    :value="vrachtwagen.id"
                    :selected="bestelling.vrachtwagen"
                  >
                    {{ vrachtwagen.beschrijving }} ({{
                      vrachtwagen.nummerplaat
                    }})
                  </option>
                </select>
                <label>Chauffeur</label>
                <select
                  class="form-control"
                  v-model="bestelling.ophalingschauffeur"
                  :disabled="beschikbaarheidscheck"
                >
                  <option value>- Kies een chauffeur -</option>
                  <option
                    v-for="chauffeur in chauffeurs"
                    :key="chauffeur.id"
                    :value="chauffeur.id"
                    :selected="bestelling.chauffeur"
                  >
                    {{ chauffeur.naam }}
                  </option>
                </select>
                <hr />
                <label>Stortplaats</label>
                <select class="form-control" v-model="bestelling.stortplaats">
                  <option value>- Kies een stortplaats -</option>
                  <option
                    v-for="stortplaats in stortplaatsen"
                    :key="stortplaats.id"
                    :value="stortplaats.id"
                    :selected="bestelling.stortplaats"
                  >
                    {{ stortplaats.beschrijving }}
                  </option>
                </select>
                <hr />
                <label>Gewicht (kg)</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="bestelling.gewicht"
                  placeholder="Gewicht"
                />
                <label>Betalingsstatus</label>
                <select
                  class="form-control"
                  v-model="bestelling.betalingsstatus"
                  :selected="bestelling.chauffeur"
                >
                  <option value="Niet betaald">Niet betaald</option>
                  <option value="Betaald">Betaald</option>
                </select>
                <label>Opmerking</label>
                <select class="form-control" v-model="bestelling.opmerkingen">
                  <option value disabled>- Selecteer opmerking -</option>
                  <option value="Niemand aanwezig">Niemand aanwezig</option>
                  <option value="Niemand aanwezig voor betaling">
                    Niemand aanwezig voor betaling
                  </option>
                  <option value="Container boven rand geladen">
                    Container boven rand geladen
                  </option>
                  <option value="Container overladen (gewicht)">
                    Container overladen (gewicht)
                  </option>
                  <option value="Wachttijd overschreden (15min.)">
                    Wachttijd overschreden (15min.)
                  </option>
                  <option value="Container onmogelijk bereikbaar">
                    Container onmogelijk bereikbaar
                  </option>
                </select>
                <label>Notities</label>
                <textarea
                  class="form-control"
                  v-model="bestelling.notities"
                  placeholder="Notities"
                ></textarea>
                <button
                  v-if="checkNewBestelling === false"
                  type="button"
                  class="btn btn-secondary float-right mt-2"
                  v-on:click="printVrachtbon(bestelling.id, 'ophaling')"
                >
                  Print vrachtbon
                </button>
              </div>

              <div
                role="tabpanel"
                class="tab-pane"
                id="fotosTab"
                v-if="bestelling"
              >
                <div class="upload-container">
                  <vue-upload-multiple-image
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    :data-images="bestelling.fotos"
                  ></vue-upload-multiple-image>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="checkNewBestelling === false"
              type="button"
              class="btn btn-danger"
              v-on:click="deleteBestelling()"
            >
              Verwijderen
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Sluiten
            </button>
            <button
              v-if="checkNewBestelling"
              type="button"
              class="btn btn-primary"
              v-on:click="createBestelling()"
            >
              Opslaan
            </button>
            <button
              v-else
              type="button"
              class="btn btn-primary"
              v-on:click="updateBestelling()"
            >
              Aanpassen
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="nieuweWerfModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Nieuwe werf aanmaken
            </h5>
          </div>
          <div class="modal-body">
            <div v-if="werf">
              <label>Beschrijving</label
              ><input
                type="text"
                class="form-control"
                v-model="werf.beschrijving"
                placeholder="Beschrijving"
              />
              <label>Straat</label
              ><input
                type="text"
                class="form-control"
                v-model="werf.straat"
                placeholder="Straat"
              />
              <label>Huisnummer</label
              ><input
                type="text"
                class="form-control"
                v-model="werf.huisnummer"
                placeholder="Huisnummer"
              />
              <label>Postcode</label
              ><input
                type="text"
                class="form-control"
                v-model="werf.postcode"
                placeholder="Postcode"
              />
              <label>Gemeente</label
              ><input
                type="text"
                class="form-control"
                v-model="werf.gemeente"
                placeholder="Gemeente"
              />
              <label>Land</label
              ><input
                type="text"
                class="form-control"
                v-model="werf.land"
                placeholder="Land"
              />
              <hr />
              <label>Contactpersoon</label>
              <input
                type="text"
                class="form-control"
                v-model="werf.contactpersoon"
                placeholder="Contactpersoon"
              />
              <label>Telefoon</label>
              <input
                type="text"
                class="form-control"
                v-model="werf.telefoon"
                placeholder="Telefoon"
              />
              <label>E-mail</label>
              <input
                type="text"
                class="form-control"
                v-model="werf.email"
                placeholder="E-mail"
              />
              <hr />
              <label>Plaatsing</label>
              <select class="form-control" v-model="werf.plaatsing">
                <option value="">- Kies plaatsingstype -</option>
                <option value="Openbaar">Openbaar</option>
                <option value="Privé">Privé</option>
              </select>
              <label>Opmerking</label>
              <textarea
                class="form-control"
                v-model="werf.opmerking"
                placeholder="Opmerking"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              v-on:click="returnModal()"
            >
              Terug
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-on:click="createWerf()"
            >
              Opslaan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "bootstrap";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/nl-be";
import moment from "moment";
import "moment/locale/nl-be";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import VueUploadMultipleImage from "vue-upload-multiple-image";
//import { filter } from "vue/types/umd";

moment.updateLocale("nl-be", {
  week: {
    dow: 1, // Monday is the first day of the week
  },
});

export default {
  name: "app",
  components: {
    DatePicker,
    VueTimepicker,
    ModelListSelect,
    VueUploadMultipleImage,
  },
  data() {
    return {
      beschikbaarheidscheck: true,
      checkNewBestelling: false,
      importType: "-1",
      importCategory: "-1",
      beschikbaarheidFeedback: "",
      types: [
        {
          name: "Bestellingen",
        },
        {
          name: "Bestellingen",
        },
        {
          name: "Leveradressen",
        },
      ],
      idemAdres: false,
      editModalTitle: "",
      bestelling: {
        mail: 1,
      },
      klantnaam: "",
      contacten: {},
      vrachtwagens: {},
      chauffeurs: {},
      transportzones: {},
      stortplaatsen: {},
      containers: {},
      afvalproducten: {},
      klanten: [],
      werven: {},
      werf: {
        klant: "",
      },
      bestellingen: {
        attributes: [],
        related: [],
      },
      bestellingColumns: [
        {
          label: "#",
          field: "id",
          type: "number",
          filterOptions: { enabled: false },
        },
        {
          label: "Klant",
          field: (row) => this.fnKlant(row),
          filterOptions: { enabled: true, filterFn: this.fnFilterKlant },
        },
        {
          label: "Adres",
          field: (row) => this.fnAdres(row),
          filterOptions: { enabled: true, filterFn: this.fnFilterKlant },
        },
        {
          label: "Levering",
          field: "leveringsdatum",
          filterOptions: { enabled: true },
        },
        {
          label: "Ophaling",
          field: "ophalingsdatum",
          filterOptions: { enabled: true },
        },
        {
          label: "Afvalproduct",
          field: "afval_info.naam",
          filterOptions: { enabled: true },
        },
        {
          label: "Container",
          field: "container_info.beschrijving",
          filterOptions: { enabled: true },
        },
        {
          html: true,
          label: "Betaald",
          field: (row) => this.fnBetalingsstatus(row),
          filterOptions: { enabled: true },
        },
      ],
      attrPos: 0,
    };
  },
  mounted() {
    this.getBestellingen();
    this.getVrachtwagens();
    this.getChauffeurs();
    this.getTransportzones();
    this.getContainers();
    this.getStortplaatsen();
    this.getAfvalproducten();
  },
  computed: {
    transportzones_ff: function() {
      return this.transportzones.filter(function(zone) {
        return zone.type == "Forfaitair";
      });
    },
    transportzones_pt: function() {
      return this.transportzones.filter(function(zone) {
        return zone.type !== "Forfaitair";
      });
    },
  },
  methods: {
    checkinput() {
      console.log(this.bestelling);
    },
    changeWerf() {
      if (this.bestelling.werf == "new") {
        $("#bestellingModal").modal("hide");
        $("#nieuweWerfModal").modal("show");
        this.bestelling.werf = "";
      }
    },
    changeCustomer(item) {
      this.getWerven(item);
    },
    uploadImageSuccess() {
      axios
        .post("https://hofman.weblion.be/api/afbeeldingen/", {
          bestelling: this.bestelling,
        })
        .then((response) => {
          console.log(response.data);
        });
    },
    beforeRemove(index, done) {
      done();

      axios
        .post("https://hofman.weblion.be/api/afbeeldingen/", {
          bestelling: this.bestelling,
        })
        .then((response) => {
          console.log(response.data);
        });
    },
    idemAdresChanged() {
      if (this.idemAdres) {
        for (let i = 0; i < this.klanten.length; i++) {
          if (this.klanten[i].id == this.bestelling.klant) {
            this.werf.straat = this.klanten[i].straat;
            this.werf.huisnummer = this.klanten[i].huisnummer;
            this.werf.gemeente = this.klanten[i].gemeente;
            this.werf.postcode = this.klanten[i].postcode;
            this.werf.land = this.klanten[i].land;
          }
        }
      } else {
        this.werf.straat = "";
        this.werf.huisnummer = "";
        this.werf.gemeente = "";
        this.werf.postcode = "";
        this.werf.land = "";
      }
    },
    fnBetalingsstatus(rowObj) {
      if (rowObj.betalingsstatus == "Betaald") {
        return "<span class='p'></span> Betaald";
      } else {
        return "<span class='np'></span> Niet betaald";
      }
    },
    fnOphaling(rowObj) {
      if (rowObj.ophalingsdatum == "0000-00-00") {
        return "-";
      } else {
        return rowObj.ophalingsdatum;
      }
    },
    fnAdres(rowObj) {
      if (rowObj.gegevens_idem_klant == "1") {
        if (rowObj.klant_info !== null) {
          return (
            rowObj.klant_info.straat +
            " " +
            rowObj.klant_info.huisnummer +
            ", " +
            rowObj.klant_info.postcode +
            " " +
            rowObj.klant_info.gemeente
          );
        } else {
          return "";
        }
      } else {
        if (rowObj.werf_info !== null) {
          return (
            rowObj.werf_info.straat +
            " " +
            rowObj.werf_info.huisnummer +
            ", " +
            rowObj.werf_info.postcode +
            " " +
            rowObj.werf_info.gemeente
          );
        } else {
          return "";
        }
      }
    },
    fnKlant(rowObj) {
      if (rowObj.klant_info) {
        if (rowObj.klant_info.type == "Particulier") {
          return rowObj.klant_info.naam + " " + rowObj.klant_info.voornaam;
        } else {
          return rowObj.klant_info.bedrijfsnaam;
        }
      }
    },
    fnFilterKlant(data, filterString) {
      console.log(data + ", " + filterString);

      if (typeof data !== "undefined") {
        return data.toLowerCase().includes(filterString.toLowerCase());
      } else {
        return false;
      }
    },
    printVrachtbon(id, type) {
      window.open(
        "https://hofman.weblion.be/api/pdf.php?b=" + id + "&type=" + type,
        "_blank"
      );
    },
    checkBeschikbaarheidFeedback() {
      this.beschikbaarheidFeedback = "";
      var teCheckenDatum = moment(this.bestelling.leveringsdatum, "YYYY-MM-DD");
      var teCheckenContainer = this.bestelling.container;

      for (var i = 0; i < this.bestellingen.length; i++) {
        if (teCheckenContainer == this.bestellingen[i]["container"]) {
          if (
            teCheckenDatum.isAfter(
              moment(this.bestellingen[i]["leveringsdatum"], "YYYY-MM-DD")
            )
          ) {
            if (this.bestellingen[i]["ophalingsdatum"] == "0000-00-00") {
              this.beschikbaarheidFeedback =
                "<span class='badge badge-warning'>Let op: ophalingsdatum onbekend!</span>";
              break;
            }
          }
        }
      }
    },
    checkBeschikbaarheid() {
      var nietBeschikbareContainers = [];

      for (var i = 0; i < this.bestellingen.length; i++) {
        var teCheckenDatum = moment(
          this.bestelling.leveringsdatum,
          "YYYY-MM-DD"
        );
        var ophalingsdatum = this.bestellingen[i]["ophalingsdatum"];
        var leveringsdatum = this.bestellingen[i]["leveringsdatum"];

        if (teCheckenDatum.isBetween(leveringsdatum, ophalingsdatum)) {
          nietBeschikbareContainers.push(this.bestellingen[i]["container"]);
        }
      }

      for (var ii = 0; ii < this.containers.length; ii++) {
        if (nietBeschikbareContainers.includes(this.containers[ii]["id"])) {
          this.containers[ii]["beschikbaar"] = false;
        } else {
          this.containers[ii]["beschikbaar"] = true;
        }
      }

      if (this.bestelling.ophalingsdatum !== undefined) {
        if (this.bestelling.ophalingsdatum !== null) {
          this.beschikbaarheidscheck = false;
        } else {
          this.beschikbaarheidscheck = true;
        }
      }

      this.beschikbaarheidscheck = false;

      console.log(this.beschikbaarheidscheck);
    },
    werfFn(rowObj) {
      var werven = this.werven;
      var werf_id = rowObj.werf;

      for (var i = 0; i < werven.length; i++) {
        if (werven[i]["id"] == werf_id) {
          return werven[i]["beschrijving"];
        }
      }
    },
    adresFn(rowObj) {
      return rowObj.straat + " " + rowObj.huisnummer;
    },
    getContainers() {
      axios
        .get("https://hofman.weblion.be/api/containers/")
        .then((response) => {
          response.data.sort((a, b) => a.grootte - b.grootte);
          this.containers = response.data;
        });
    },
    getStortplaatsen() {
      axios
        .get("https://hofman.weblion.be/api/stortplaatsen/")
        .then((response) => {
          this.stortplaatsen = response.data;
        });
    },
    getAfvalproducten() {
      axios
        .get("https://hofman.weblion.be/api/afvalproducten/")
        .then((response) => {
          this.afvalproducten = response.data;
        });
    },
    getBestellingen() {
      axios
        .get("https://hofman.weblion.be/api/bestellingen/")
        .then((response) => {
          this.bestellingen = response.data;
          console.log(this.bestellingen);
        });
    },
    getVrachtwagens() {
      axios
        .get("https://hofman.weblion.be/api/vrachtwagens/")
        .then((response) => {
          this.vrachtwagens = response.data;
        });
    },
    getChauffeurs() {
      axios
        .get("https://hofman.weblion.be/api/chauffeurs/")
        .then((response) => {
          this.chauffeurs = response.data;
        });
    },
    getTransportzones() {
      axios
        .get("https://hofman.weblion.be/api/transportzones/")
        .then((response) => {
          this.transportzones = response.data;
        });
    },
    getWerven(klant) {
      axios
        .get("https://hofman.weblion.be/api/werven/", {
          params: {
            klant: klant,
          },
        })
        .then((response) => {
          console.log("werven", response.data);
          this.werven = response.data;
        });
    },
    deleteBestelling() {
      axios
        .delete("https://hofman.weblion.be/api/bestellingen/", {
          data: {
            bestelling_id: this.bestelling.id,
          },
        })
        .then((response) => {
          this.getBestellingen();
          $("#bestellingModal").modal("hide");
          console.log(response.data);
        });
    },
    updateBestelling() {
      axios
        .put("https://hofman.weblion.be/api/bestellingen/", {
          bestelling: this.bestelling,
        })
        .then((response) => {
          this.getBestellingen();
          $("#bestellingModal").modal("hide");
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    createBestelling() {
      axios
        .post("https://hofman.weblion.be/api/bestellingen/", {
          bestelling: this.bestelling,
        })
        .then((response) => {
          this.getBestellingen();
          $("#bestellingModal").modal("hide");
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    modalNieuweWerf() {
      this.werf.klant = this.bestelling.klant;
      for (let i = 0; i < this.klanten.length; i++) {
        if (this.klanten[i].id == this.bestelling.klant) {
          this.klantnaam = this.klanten[i].bedrijfsnaam;
        }
      }
      $("#bestellingModal").modal("hide");
      $("#nieuweWerfModal").modal("show");
    },
    returnModal() {
      $("#bestellingModal").modal("show");
      $("#nieuweWerfModal").modal("hide");
    },
    modalToevoegenBestelling() {
      this.bestelling = {
        mail: 1,
        klant_info: {
          betalingstermijn: "",
        },
        ophalingsrichtuur: "",
        leveringsrichtuur: "",
      };
      this.editModalTitle = "Bestelling toevoegen";

      this.beschikbaarheidscheck = true;
      this.checkNewBestelling = true;

      axios.get("https://hofman.weblion.be/api/klanten/").then((res) => {
        this.klanten = [res.data][0];
        $("#bestellingModal").modal("show");
      });
    },
    onRowClick(table) {
      this.editModalTitle = "Bestelling aanpassen";
      this.bestelling = table.row;

      if (this.bestelling.fotos == "") {
        this.bestelling.fotos = [];
      }

      this.beschikbaarheidscheck = false;
      this.checkNewBestelling = false;

      if (this.bestelling.klant) {
        this.getWerven(this.bestelling.klant);
      }

      axios.get("https://hofman.weblion.be/api/klanten/").then((res) => {
        console.log(res.data);
        this.klanten = res.data;
        $("#bestellingModal").modal("show");
      });
    },
    selectionChanged(table) {
      this.bestellingenSelected = table.selectedRows;
    },
    modalAanpassenBestelling() {
      this.checkNewBestelling = false;
      this.editModalTitle = "Bestelling aanpassen";

      $("#bestellingModal").modal("show");
    },
    sBestelling() {
      axios
        .post("https://hofman.weblion.be/api/bestellingen/update.php", {
          bestelling: this.bestelling,
        })
        .then((res) => {
          console.log(res);
          this.getBestellingen();
        })
        .then(function() {
          $("#bestellingModal").modal("hide");
        });
    },
    createWerf() {
      this.werf.klant = this.bestelling.klant;

      axios
        .post("https://hofman.weblion.be/api/werven/", {
          werf: this.werf,
        })
        .then((response) => {
          this.getWerven(this.bestelling.klant);
          $("#bestellingModal").modal("show");
          $("#nieuweWerfModal").modal("hide");
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>

<style>
button {
  margin-right: 10px;
}
.table thead th {
  text-align: left !important;
}
.pager ul {
  list-style-type: none;
}
.pager ul li {
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}
.modal input,
.modal select {
  margin-bottom: 5px;
}
.modal-body label {
  display: inline-block;
  width: 32%;
}

.modal-body .form-control {
  display: inline-block;
  width: 68%;
}

.modal-body select {
  text-indent: 0px;
}

.vue__time-picker input.display-time {
  display: inline-block;
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 3px;
  text-indent: 4px;
  color: #555;
}

.vue__time-picker {
  display: inline-block;
  width: 68%;
}

#exampleModal input {
  display: block;
  width: 100%;
}

#importModal .modal-body label {
  width: auto;
}

#importModal input,
#importModal select {
  display: inline-block;
  width: 49%;
  margin-bottom: 5px;
}

#importModal .match-wrapper,
#importModal form {
  width: 100%;
}
#importModal select {
  margin-left: 1%;
}

#importModal .fullw {
  display: block;
  width: 100%;
  border-radius: 4px;
}

#importModal .fullw select {
  margin: 0;
}

#importModal .fullw input {
  display: block;
  width: 100%;
  margin: 0;
}

.dropdown {
  display: inline-block;
}
.dropdown-item:hover {
  cursor: pointer !important;
}
.dropdown-item i {
  margin-right: 3px;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 550px;
    margin: 1.75rem auto;
  }
}
.groupedState {
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin-left: 25%;
}

#autoGroupModal table tr td {
  padding: 2px 10px;
}

#autoGroupModal .modal-title span {
  color: #777;
  font-size: 14px;
  margin-left: 10px;
}

#autoGroupModal input {
  width: 100%;
}

#autoGroupModal .form-check-input {
  width: auto;
  position: relative;
  margin: 0;
  vertical-align: 2px;
}

.ck.ck-editor {
  display: inline-block !important;
  width: 68% !important;
  margin-bottom: 5px !important;
}

.sticky-nav {
  position: fixed;
  height: 150px;
  top: 50;
  z-index: 2;
  background: white;
  padding-top: 10px;
  width: 100%;
  margin-top: -10px;
}

#bestellingModal textarea {
  height: 100px;
}

.vgt-wrap {
  margin-top: 120px;
}

label {
  vertical-align: top;
}

[data-g="1"] {
  background: #8cc040;
}

[data-g="0"] {
  background: red;
}

.modal input,
.modal .ui.search.dropdown,
.modal .mx-datepicker {
  display: inline-block;
  width: 68%;
  margin-bottom: 5px;
  font-size: 1rem;
}
.modal .ui.dropdown:not(.button) > .default.text {
  color: #6d767d;
}
.modal .mx-datepicker input {
  width: 100%;
  height: 38px;
  text-indent: 2px;
  font-size: 1rem;
}
.mx-datepicker-popup {
  z-index: 9999;
}
.mx-icon-calendar {
  margin-top: 0px;
}
.mx-input {
  box-shadow: none;
  border: 1px solid #ced4da;
}
.modal .ui.search.dropdown {
  border: 1px solid #ced4da;
}
.modal .ui.dropdown > .text {
  color: #495057;
}
.modal .mx-datepicker input {
  margin-bottom: 0px;
}
.btn-danger {
  margin-right: 210px;
}
.lnk {
  display: inline-block;
  width: 68%;
  font-size: 14px;
  padding-bottom: 10px;
  margin-top: -3px;
  text-decoration: underline;
  color: #007bff;
}
.checkContainer {
  width: 68%;
  display: inline-block;
}
.checkContainer input {
  display: inline-block;
  width: 16px;
  margin-bottom: 15px;
}
.checkContainer span {
  font-size: 15px;
}
.tab-content {
  padding-top: 25px;
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.image-edit {
  display: none !important;
}

.image-container {
  width: 390px !important;
  height: 230px !important;
}

.image-list-item {
  width: 50px !important;
  height: 50px !important;
}

.image-list-container {
  max-width: 300px !important;
}

.image-list-container .image-list-item .show-img {
  max-width: 35px !important;
  max-height: 27px !important;
}

.modal .idem {
  display: inline-block;
  width: auto;
}

.modal input.idem {
  margin-right: 5px;
  width: 15px;
  height: 15px;
}

.modal label.idem {
  font-size: 14px;
}

.idem-container {
  display: inline-block;
  width: 68%;
}

.modal-body .idem-container .form-control {
  width: 100%;
}

.modal {
  overflow-y: auto;
}

.p,
.np {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #8cc040;
  margin-right: 3px;
}

.np {
  background-color: #d2212d;
}
</style>
